import React from "react";

const SpreadsheetStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 4.84998C2.58579 4.84998 2.25 5.18576 2.25 5.59998C2.25 6.01419 2.58579 6.34998 3 6.34998H8.5C8.91421 6.34998 9.25 6.01419 9.25 5.59998C9.25 5.18576 8.91421 4.84998 8.5 4.84998H3ZM11.5 4.84998C11.0858 4.84998 10.75 5.18576 10.75 5.59998C10.75 6.01419 11.0858 6.34998 11.5 6.34998H17C17.4142 6.34998 17.75 6.01419 17.75 5.59998C17.75 5.18576 17.4142 4.84998 17 4.84998H11.5ZM2.25 10.1C2.25 9.68576 2.58579 9.34998 3 9.34998H8.5C8.91421 9.34998 9.25 9.68576 9.25 10.1C9.25 10.5142 8.91421 10.85 8.5 10.85H3C2.58579 10.85 2.25 10.5142 2.25 10.1ZM11.5 9.34998C11.0858 9.34998 10.75 9.68576 10.75 10.1C10.75 10.5142 11.0858 10.85 11.5 10.85H17C17.4142 10.85 17.75 10.5142 17.75 10.1C17.75 9.68576 17.4142 9.34998 17 9.34998H11.5ZM2.25 14.35C2.25 13.9358 2.58579 13.6 3 13.6H8.5C8.91421 13.6 9.25 13.9358 9.25 14.35C9.25 14.7642 8.91421 15.1 8.5 15.1H3C2.58579 15.1 2.25 14.7642 2.25 14.35ZM11.5 13.6C11.0858 13.6 10.75 13.9358 10.75 14.35C10.75 14.7642 11.0858 15.1 11.5 15.1H17C17.4142 15.1 17.75 14.7642 17.75 14.35C17.75 13.9358 17.4142 13.6 17 13.6H11.5Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SpreadsheetStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;